export default "__VITE_ASSET__DwockYc$__"